// @flow
const initialState = {
  features: ''
};
export default initialState;